import { Row, Col, Button, notification, Grid } from "antd";
import "./ContentHeader.scss";
import { capitalizeString } from "../../../shared/util";
import {
  User,
  RoleType,
  AuthMessages,
  TokenType,
  RequestStatus,
  RecordStatus,
} from "../..";
import { registerUser } from "../../../controllers/auth";
import { saveRequest, sendNotification } from "../../../controllers/connection";
import { ActionsetUser } from "../../../controllers/store/actions/user/actions";
import { RequestConnection } from "../../../models/RequestConnection";
import ConnectionRequest from "../Forms/Modal/ConnectionRequest/Connection-Request";
import RegisterModal from "../Forms/Modal/Register";
import {
  NotificationPlacement,
  IconType,
} from "antd/es/notification/interface";
import { useState } from "react";
import store from "../../../controllers/store";
import { useSelector } from "react-redux";
import { UserAddOutlined } from "@ant-design/icons";
import { getSended } from "../../../controllers/store/actions/connection/connection-sended-actions";

type NotificationType = "success" | "info" | "warning" | "error";

interface Props {
  values?: any;
  title: string;
  subTitle?: string;
}
const { useBreakpoint } = Grid;
export const ContentHeader = (Props: Props) => {
  const screens = useBreakpoint();
  return (
    <div className="content-header">
      <Row gutter={[8, 8]} style={{ width: "100%" }}>
        <Col xs={24} sm={12} md={8} lg={12}>
          <h1
            className={
              screens.xs
                ? "heading-content-title font-small"
                : "heading-content-title"
            }
          >
            {Props.title}{" "}
            <span className="heading-content-subtitle">
              {Props.subTitle || "Proveedora"}
            </span>{" "}
          </h1>
        </Col>
      </Row>
    </div>
  );
};
const dispatch = store.dispatch;

export const ContentHeaderDetailed = (Props: Props) => {
  const screens = useBreakpoint();
  const user = useSelector((state: any) => {
    return state.user.user;
  });
  const [modalTopicsVisible, setModalTopicsVisible] = useState(
    localStorage.getItem("topics") ? false : true
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notify, setNotification] = useState(false);
  const [contact, setContact] = useState({} as any);
  const [isModalRegisterOpen, setIsModalRegisterOpen] = useState(false);
  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type: NotificationType) => {
    api[type]({
      message: "UNAB",
      description: "Solicitud enviada correctamente.",
    });
  };

  const openNotification = (placement: NotificationPlacement) => {
    api.info({
      type: TokenType.success as IconType,
      message: AuthMessages.Title,
      description: AuthMessages.AccountCreated,
      placement,
    });
  };

  return (
    <div className="content-header" style={{ padding: 40 }}>
      {contextHolder}
      <RegisterModal
        toggleLogin={true}
        visible={isModalRegisterOpen}
        onSuccessLogin={(user: User) => {
          dispatch(ActionsetUser(user));
          setIsModalRegisterOpen(false);
        }}
        onCancel={() => setIsModalRegisterOpen(false)}
        onRegister={async (values: any) => {
          try {
            const response = await registerUser({
              ...values,
              metadata: {
                role: RoleType.KnowledgeConsumer,
              },
            });

            setNotification(true);
            setIsModalRegisterOpen(false);

            if (response) {
              setModalTopicsVisible(true);
            }
          } catch (error) {
            setNotification(true);
            setIsModalRegisterOpen(false);
          }
        }}
      />
      <ConnectionRequest
        open={isModalOpen}
        onOk={(value: any, text: string) => {
          const request = new RequestConnection(
            "",
            text,
            user.me,
            {
              name: contact?.name || "",
              email: contact?.email || "",
              organization_name:
                contact?.organization_name || contact?.name || "",
              type: contact?.type || "",
            },
            RequestStatus.Pending,
            value.requestType || "",
            contact?.type
          );

          saveRequest(request);
          sendNotification(request);
          setIsModalOpen(false);
          openNotificationWithIcon("success");
          dispatch(
            getSended(
              "connection_request",
              {
                meta: "filter_count",
                filter: `&filter[user_created][id][_eq]=${user.me.id}&filter[status][_eq]=${RecordStatus.Active}`,
              },
              1,
              10
            )
          );
        }}
        onCancel={() => setIsModalOpen(false)}
        contact={{
          name: contact?.name || "",
          email: contact?.email || "",
          organization_name: contact?.organization_name || "",
          type: contact?.type || "",
        }}
      />
      <Row
        gutter={[8, 8]}
        style={{ width: "100%", display: "flex", alignItems: "center" }}
      >
        <Col xs={24} sm={12} md={8} lg={12}>
          <h1
            className={
              screens.xs
                ? "heading-content-title font-small"
                : "heading-content-title"
            }
          >
            {Props.values[0]?.name?.toUpperCase()}
            <span className="heading-content-subtitle">
              {Props.values[0]?.type}
            </span>{" "}
          </h1>
        </Col>
        <Col
          xs={24}
          sm={12}
          md={8}
          lg={12}
          style={{ display: "table", textAlign: "right" }}
        >
          <Button
            icon={<UserAddOutlined />}
            type="primary"
            onClick={() => {
              if (user) {
                setIsModalOpen(!isModalOpen);
                console.log("contact", Props);
                setContact({
                  name: Props.values[0].name,
                  type: Props.values[0].type,
                  email: Props.values[0].email,
                });
              } else {
                setIsModalRegisterOpen(!isModalRegisterOpen);
              }
            }}
          >
            Conectar
          </Button>
        </Col>
      </Row>
    </div>
  );
};
